import { Link } from "react-router-dom"
import { FormStepCard } from "../../../common/components/form_steps"
import { InfoText } from "../../../common/components/info_text"
import { SectionDivider } from "../../../common/components/section_divider"
import { textChooser } from "../../../common/util/textChooser"

export const ConfirmationScreen = () => {
  return (
    <FormStepCard title={textChooser("txt47")} showBackButton={false}>
      <>
        <InfoText text={textChooser("txt53")} type="plain" />
        <SectionDivider className="-lined" />
        <Link to="/login">{textChooser("txt1")}</Link>
      </>
    </FormStepCard>
  )
}